import { useState } from 'react'
import { SDrawerOrModal, SGeneralForms } from 'shj-components'
import { Button, Form, Radio, Input, message } from 'antd'
import { getUser } from 'shj-utils'
import { flowDetailFinish } from '@/services/order'

interface IProps {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  record?: any
  flowData: any
  reload: any
}

const { TextArea } = Input;

export default function ProcessModal(prpos: IProps) {
  const { open, title, setOpen, reload = () => ({}), flowData = {} } = prpos
  const [form] = Form.useForm()
  const [btnLoading, setBtnLoading] = useState(false);

  const processAdvices = Form.useWatch('processAdvices', form)

  const getTaskItem = (list: Array<any>) => {
  const tempList = list || []
  const ucenterUserId = getUser()?.ucenterUserId
  const tempItem = tempList.find(item => (item['nodeWorkNumberList'] || []).includes(ucenterUserId))
  if (tempItem) {
    return tempItem
  }
  return tempList[0] || {}
}

  const onsubmit = () => {
    form.validateFields().then( async (value) => {
      const flow = getTaskItem(flowData?.currentAuditList)

      if (!flow.taskId) {
        message.error('当前没有审批节点')
        return
      }

      // 提交接口前对提交数据进行处理
      const params = {
        variables: {
          ...flowData?.variables,
          state: value.processAdvices ? '1' : '2',
        }, //流程变量
        taskId: flow.taskId,
        userId: getUser()?.ucenterUserId,
        comment: value.remark,
      }

      setBtnLoading(true);

      await flowDetailFinish({
        data: params
      })

      setBtnLoading(false);

      message.success(value.processAdvices ? '审批成功' : '驳回成功')
      onCancel();
      reload();
    }).catch(err => {
      console.log(err)
      setBtnLoading(false);
    })
  }
  const onCancel = () => {
    setOpen(false)
  }

  return (
    <SDrawerOrModal
      title={title}
      mode="modal"
      open={open}
      width={500}
      onCancel={onCancel}
      antdProps={{
        footer: (
          <div>
            <Button onClick={onCancel}>取消</Button>
            <Button
              style={{ marginLeft: 15 }}
              loading={btnLoading}
              type="primary"
              onClick={onsubmit}
            >
              确定
            </Button>
          </div>
        ),
        maskClosable: false,
      }}
    >
      <div>
        <Form
          form={form}
          layout="horizontal"
          style={{
            width: '100%',
          }}
        >
          <Form.Item label="审核意见" name="processAdvices" rules={[{required: true, message: `审核意见不能为空`}]}>
            <Radio.Group>
              <Radio value={1}> 同意 </Radio>
              <Radio value={0}> 驳回 </Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item name="remark" rules={[{required: !processAdvices, message: `审核备注不能为空`}]}>
            <TextArea placeholder='请填写审批备注' rows={4} maxLength={200} />
          </Form.Item>
        </Form>
      </div> 
    </SDrawerOrModal>
  )
}
